export default __webpack_public_path__ + "static/media/nu.8c86d48e.svg";